import { motion } from "framer-motion";
import Logo from "@/components/Logo";
import LangSwitch from "@/components/LangSwitch";
import { useLang } from "@/lib/i18n";

export const EntryGate = ({ onEnter }) => {
  const { t } = useLang();
  return (
    <motion.div
      data-testid="entry-screen-overlay"
      className="fixed inset-0 z-[200] bg-obsidian flex flex-col items-center justify-center px-6 text-center"
      exit={{ opacity: 0, scale: 1.03, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } }}
    >
      <div className="grain-overlay" />
      <div className="absolute top-6 right-6 sm:top-8 sm:right-8">
        <LangSwitch scope="gate" />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="flex flex-col items-center"
      >
        <div className="mb-8">
          <Logo />
        </div>
        <p className="font-mono text-[10px] sm:text-xs tracking-[0.35em] text-gold/80 uppercase mb-6">
          {t("gate.eyebrow")}
        </p>
        <h1 className="font-serif font-light text-cream text-3xl sm:text-5xl leading-tight max-w-xl">
          {t("gate.line1")}
          <span className="block italic text-gold">{t("gate.line2")}</span>
        </h1>
        <button
          data-testid="entry-screen-enter-button"
          onClick={onEnter}
          className="group mt-12 relative overflow-hidden border border-gold/60 px-12 py-5 font-mono text-xs sm:text-sm tracking-[0.4em] text-gold uppercase transition-colors duration-500 hover:text-obsidian"
        >
          <span className="absolute inset-0 bg-gold scale-x-0 origin-left transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-x-100" />
          <span className="relative">{t("gate.button")}</span>
        </button>
        <p className="mt-10 font-mono text-[10px] tracking-[0.25em] text-smoke uppercase">
          {t("gate.hint")}
        </p>
      </motion.div>
    </motion.div>
  );
};

export default EntryGate;
